module.exports = __webpack_public_path__ + "img/back-charts.eba90c01.png";